import { Box, Typography } from '@mui/material';
import { DATAGRID_TABLE_CELL_WIDTH } from '../../../../utils/constants';

const strippingTableColumns = (renderValueCell, renderActions, renderTripPipeTypeCell, renderReportEveryCell, renderCell, renderDrillFluidCell, units, renderTargetsEditAction) => [
  {
    field: 'runNumber',
    headerName: 'Run',
    headerAlign: 'center',
    align: 'center',
    renderCell,
  },
  {
    field: 'from',
    headerName: `From MD (${units?.from?.label})`,
    renderHeader: () => (
      <Box>
        <Typography sx={{ fontSize: '1.2rem' }}>
          From MD
        </Typography>
        <Typography sx={{ fontSize: '1.2rem' }}>
         {`(${units?.from?.label})`}
        </Typography>
      </Box>
    ),
    headerAlign: 'center',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 50,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    align: 'center',
    renderEditCell: renderValueCell,
    editable: true,
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return value.toFixed(units?.from?.decimals);
    },
  },
  {
    field: 'to',
    headerName: `To MD (${units?.to?.label})`,
    renderHeader: () => (
      <Box>
        <Typography sx={{ fontSize: '1.2rem' }}>
          To MD
        </Typography>
        <Typography sx={{ fontSize: '1.2rem' }}>
         {`(${units?.to?.label})`}
        </Typography>
      </Box>
    ),
    headerAlign: 'center',
    align: 'center',
    renderEditCell: renderValueCell,
    editable: true,
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return value.toFixed(units?.to?.decimals);
    },
  },
  {
    field: 'speed',
    headerName: `Trip Speed (${units?.speed?.label})`,
    renderHeader: () => (
      <Box>
        <Typography sx={{ fontSize: '1.2rem' }}>
          Trip Speed
        </Typography>
        <Typography sx={{ fontSize: '1.2rem' }}>
         {`(${units?.speed?.label})`}
        </Typography>
      </Box>
    ),
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    headerAlign: 'center',
    align: 'center',
    renderEditCell: renderValueCell,
    editable: true,
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return value.toFixed(units?.speed?.decimals);
    },
  },
  {
    field: 'tubular',
    headerName: 'Tubular',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderTripPipeTypeCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'report_interval',
    headerName: `Intervals (${units?.report_interval?.label})`,
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderReportEveryCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return value.toFixed(units?.report_interval?.decimals);
    },
  },
  {
    field: 'filling_fluid_id',
    headerName: 'Filling Fluid',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH + 120,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderDrillFluidCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'target_data',
    headerName: 'Target',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH + 50,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderCell: renderTargetsEditAction,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'actions',
    headerName: 'Actions',
    headerAlign: 'center',
    align: 'center',
    renderCell: renderActions,
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 70,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH - 80,
  }
];
export { strippingTableColumns };
